//units pages - converted to lazy loading
const unitsIndex = () => import('@/pages/setting/units/index.vue')
const unitsForm = () => import('@/pages/setting/units/form.vue')

//sections pages - converted to lazy loading
const sectionsIndex = () => import('@/pages/setting/sections/index.vue')
const sectionsForm = () => import('@/pages/setting/sections/form.vue')

//customerSections pages - converted to lazy loading
const customerSectionsIndex = () => import('@/pages/setting/customerSections/index.vue')
const customerSectionsForm = () => import('@/pages/setting/customerSections/form.vue')

//supplierSections pages - converted to lazy loading
const supplierSectionsIndex = () => import('@/pages/setting/supplierSections/index.vue')
const supplierSectionsForm = () => import('@/pages/setting/supplierSections/form.vue')

//Signatures pages - converted to lazy loading
const signaturesIndex = () => import('@/pages/setting/signatures/index.vue')
const signaturesForm = () => import('@/pages/setting/signatures/form.vue')

//priceLists pages - converted to lazy loading
const priceListsIndex = () => import('@/pages/setting/priceLists/index.vue')
const priceListsForm = () => import('@/pages/setting/priceLists/form.vue')

//productOptions pages - converted to lazy loading
const productOptionsIndex = () => import('@/pages/setting/productOptions/index.vue')
const productOptionsFrom = () => import('@/pages/setting/productOptions/form.vue')

//taxes pages - converted to lazy loading
const taxesIndex = () => import('@/pages/setting/taxes/index.vue')
const taxesForm = () => import('@/pages/setting/taxes/form.vue')

//discounts pages - converted to lazy loading
const discountsIndex = () => import('@/pages/setting/discounts/index.vue')
const discountsForm = () => import('@/pages/setting/discounts/form.vue')

//users pages - converted to lazy loading
const usersIndex = () => import('@/pages/setting/users/index.vue')
const usersForm = () => import('@/pages/setting/users/form.vue')

//roles pages - converted to lazy loading
const rolesIndex = () => import('@/pages/setting/roles/index.vue')
const rolesForm = () => import('@/pages/setting/roles/form.vue')

//companies pages - converted to lazy loading
const companiesForm = () => import('@/pages/setting/companies/form.vue')

//invoiceGroups pages - converted to lazy loading
const invoiceGroupsIndex = () => import('@/pages/setting/invoiceGroups/index.vue')
const invoiceGroupsForm = () => import('@/pages/setting/invoiceGroups/form.vue')

//invoiceStatus pages - converted to lazy loading
const invoiceStatusIndex = () => import('@/pages/setting/invoiceStatus/index.vue')
const invoiceStatusForm = () => import('@/pages/setting/invoiceStatus/form.vue')

//paymentMethods pages - converted to lazy loading
const paymentMethodsIndex = () => import('@/pages/setting/paymentMethods/index.vue')
const paymentMethodsForm = () => import('@/pages/setting/paymentMethods/form.vue')

//paymentFees pages - converted to lazy loading
const paymentFeesIndex = () => import('@/pages/setting/paymentFees/index.vue')
const paymentFeesForm = () => import('@/pages/setting/paymentFees/form.vue')

//expenseSections pages - converted to lazy loading
const expenseSectionsIndex = () => import('@/pages/setting/expenseSections/index.vue')
const expenseSectionsForm = () => import('@/pages/setting/expenseSections/form.vue')

//incomeSections pages - converted to lazy loading
const incomeSectionsIndex = () => import('@/pages/setting/incomeSections/index.vue')
const incomeSectionsForm = () => import('@/pages/setting/incomeSections/form.vue')

//PaymentsSections pages - converted to lazy loading
const PaymentsSectionsIndex = () => import('@/pages/setting/PaymentsSections/index.vue')
const PaymentsSectionsForm = () => import('@/pages/setting/PaymentsSections/form.vue')

const marketersIndex = () => import('@/pages/setting/marketers/index.vue')
const marketersForm = () => import('@/pages/setting/marketers/form.vue')

const CapitalsSectionsIndex = () => import('@/pages/setting/capitalsSections/index.vue')
const CapitalsSectionsForm = () => import('@/pages/setting/capitalsSections/form.vue')
//settings - converted to lazy loading

const options = () => import('@/pages/setting/options.vue')
const profile = () => import('@/pages/setting/profile.vue')
const routes = [
  { path: '/profile', name: 'profile', component: profile },

  { path: 'units', name: 'units', component: unitsIndex },
  { path: 'units/create', name: 'unitsCreate', component: unitsForm },
  { path: 'units/:id/edit', name: 'unitsEdit', component: unitsForm },

  { path: 'capitalsSections', name: 'capitalsSections', component: CapitalsSectionsIndex },
  {
    path: 'capitalsSections/create',
    name: 'capitalsSectionsCreate',
    component: CapitalsSectionsForm
  },
  {
    path: 'capitalsSections/:id/edit',
    name: 'capitalsSectionsEdit',
    component: CapitalsSectionsForm
  },
  { path: 'sections', name: 'sections', component: sectionsIndex },
  {
    path: 'sections/create',
    name: 'sectionsCreate',
    component: sectionsForm
  },
  {
    path: 'sections/:id/edit',
    name: 'sectionsEdit',
    component: sectionsForm
  },
  {
    path: 'customerSections',
    name: 'customerSections',
    component: customerSectionsIndex
  },
  {
    path: 'customerSections/create',
    name: 'customerSectionsCreate',
    component: customerSectionsForm
  },
  {
    path: 'customerSections/:id/edit',
    name: 'customerSectionsEdit',
    component: customerSectionsForm
  },

  {
    path: 'supplierSections',
    name: 'supplierSections',
    component: supplierSectionsIndex
  },
  {
    path: 'supplierSections/create',
    name: 'supplierSectionsCreate',
    component: supplierSectionsForm
  },
  {
    path: 'supplierSections/:id/edit',
    name: 'supplierSectionsEdit',
    component: supplierSectionsForm
  },

  { path: 'signatures', name: 'signatures', component: signaturesIndex },
  {
    path: 'signatures/create',
    name: 'signaturesCreate',
    component: signaturesForm
  },
  {
    path: 'signatures/:id/edit',
    name: 'signaturesEdit',
    component: signaturesForm
  },
  { path: 'priceLists', name: 'priceLists', component: priceListsIndex },
  {
    path: 'priceLists/create',
    name: 'priceListsCreate',
    component: priceListsForm
  },
  {
    path: 'priceLists/:id/edit',
    name: 'priceListsEdit',
    component: priceListsForm
  },

  {
    path: 'productOptions',
    name: 'productOptions',
    component: productOptionsIndex
  },
  {
    path: 'productOptions/create',
    name: 'productOptionsCreate',
    component: productOptionsFrom
  },
  {
    path: 'productOptions/:id/edit',
    name: 'productOptionsEdit',
    component: productOptionsFrom
  },

  { path: 'taxes', name: 'taxes', component: taxesIndex },
  { path: 'taxes/create', name: 'taxesCreate', component: taxesForm },
  { path: 'taxes/:id/edit', name: 'taxesEdit', component: taxesForm },

  { path: 'discounts', name: 'discounts', component: discountsIndex },
  {
    path: 'discounts/create',
    name: 'discountsCreate',
    component: discountsForm
  },
  {
    path: 'discounts/:id/edit',
    name: 'discountsEdit',
    component: discountsForm
  },

  { path: 'users', name: 'users', component: usersIndex },
  { path: 'users/create', name: 'usersCreate', component: usersForm },
  { path: 'users/:id/edit', name: 'usersEdit', component: usersForm },

  { path: 'roles', name: 'roles', component: rolesIndex },
  { path: 'roles/create', name: 'rolesCreate', component: rolesForm },
  { path: 'roles/:id/edit', name: 'rolesEdit', component: rolesForm },

  {
    path: 'companies/GeneralSettings',
    name: 'companiesEdit',
    component: companiesForm
  },

  {
    path: 'invoiceGroups',
    name: 'invoiceGroups',
    component: invoiceGroupsIndex
  },
  {
    path: 'invoiceGroups/create',
    name: 'invoiceGroupsCreate',
    component: invoiceGroupsForm
  },
  {
    path: 'invoiceGroups/:id/edit',
    name: 'invoiceGroupsEdit',
    component: invoiceGroupsForm
  },
  {
    path: 'invoiceStatus',
    name: 'invoiceStatus',
    component: invoiceStatusIndex
  },
  {
    path: 'invoiceStatus/create',
    name: 'invoiceStatusCreate',
    component: invoiceStatusForm
  },
  {
    path: 'invoiceStatus/:id/edit',
    name: 'invoiceStatusEdit',
    component: invoiceStatusForm
  },
  { path: 'paymentMethods', name: 'paymentMethods', component: paymentMethodsIndex },
  {
    path: 'paymentMethods/create',
    name: 'paymentMethodsCreate',
    component: paymentMethodsForm
  },
  {
    path: 'paymentMethods/:id/edit',
    name: 'paymentMethodsEdit',
    component: paymentMethodsForm
  },
  { path: 'paymentFees', name: 'paymentFees', component: paymentFeesIndex },
  {
    path: 'paymentFees/create',
    name: 'paymentFeesCreate',
    component: paymentFeesForm
  },

  {
    path: 'paymentFees/:id/edit',
    name: 'paymentFeesEdit',
    component: paymentFeesForm
  },

  {
    path: 'expenseSections',
    name: 'expenseSections',
    component: expenseSectionsIndex
  },
  {
    path: 'expenseSections/create',
    name: 'expenseSectionsCreate',
    component: expenseSectionsForm
  },
  {
    path: 'expenseSections/:id/edit',
    name: 'expenseSectionsEdit',
    component: expenseSectionsForm
  },

  {
    path: 'incomeSections',
    name: 'incomeSections',
    component: incomeSectionsIndex
  },
  {
    path: 'incomeSections/create',
    name: 'incomeSectionsCreate',
    component: incomeSectionsForm
  },
  {
    path: 'incomeSections/:id/edit',
    name: 'incomeSectionsEdit',
    component: incomeSectionsForm
  },

  {
    path: 'PaymentsSections',
    name: 'PaymentsSections',
    component: PaymentsSectionsIndex
  },
  {
    path: 'PaymentsSections/create',
    name: 'PaymentsSectionsCreate',
    component: PaymentsSectionsForm
  },
  {
    path: 'PaymentsSections/:id/edit',
    name: 'PaymentsSectionsEdit',
    component: PaymentsSectionsForm
  },

  { path: 'marketers', name: 'marketers', component: marketersIndex },
  {
    path: 'marketers/create',
    name: 'marketersCreate',
    component: marketersForm
  },
  {
    path: 'marketers/:id/edit',
    name: 'marketersEdit',
    component: marketersForm
  },

  //settings
  {
    path: 'options',
    name: 'options',
    component: options
  }
]

export default routes
